import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { ProductFeatures } from './components/ProductFeatures';
import { BonusSection } from './components/BonusSection';
import { TargetAudience } from './components/TargetAudience';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="font-sans antialiased text-gray-900 bg-white min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBar data-id="element-2" />

      <main className="pt-[48px] md:pt-[52px]" data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ProductFeatures data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PurchaseSection data-id="element-9" />
        <TargetAudience data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-13">
        <div className="max-w-6xl mx-auto px-4" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} Mapas Mentales de Anatomía Humana.
            Todos los derechos reservados.
          </p>
          <p className="mt-2" data-id="element-16">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-17" />
    </div>;
}